import React from 'react';

import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import { URLS } from 'rebook/apps/base/constants';


const Title = () => (
  <React.Fragment>
    <div className="title-2">Всегда подскажем, что почитать</div>
    <p>Подбираем книги по темам и рейтингам, держим в курсе книжных новостей</p>
  </React.Fragment>
);

const LatestBooksetBlock = ({ latestBooksets }) => (
  <BooksetsCarousel
    title={<Title />}
    link={URLS.booksetList}
    linkText="Все подборки"
    booksets={latestBooksets}
    extraClassName="billetContainerHighlight" />
);

export default LatestBooksetBlock;
